// Keep this file free of zod: the Explorer bundles it client-side and
// must not pull the zod runtime in with it. Schemas live in zoom.ts.

// should be corrected in BQ
export const BQ_INTERVALS = [
  "24h",
  "7d",
  "30d",
  "90d",
  "max",
  "180d",
  "365d",
  "1095d",
  "1825d",
  "ytd",
  "4fullq",
] as const

export type Interval = (typeof BQ_INTERVALS)[number]

/** Sentinel day counts for the calendar-anchored zooms. Day-based intervals
 * resolve to their positive day count; these three have no fixed width, so
 * they pass through the chart pipeline's zoom slicing unsliced. */
export enum ZOOM_ENUM {
  MAX = 0,
  YTD = -1,
  FOUR_FULL_QUARTERS = -2,
}

export type ZoomValues =
  | ZOOM_ENUM.YTD
  | ZOOM_ENUM.MAX
  | ZOOM_ENUM.FOUR_FULL_QUARTERS
  | 1
  | 7
  | 30
  | 90
  | 180
  | 365
  | 1095
  | 1825

/** `interval` param → the resolved zoom day count the chart pipeline's
 * grouping/slicing operates on (`ZOOM_ENUM` sentinels for the
 * calendar-anchored zooms). Shared by the client chart pipeline and the
 * API's composed chart endpoint. */
export function convertApiToZoom(zoom: `${Interval}`): ZoomValues {
  switch (zoom) {
    case "24h":
      return 1
    case "7d":
      return 7
    case "30d":
      return 30
    case "90d":
      return 90
    case "180d":
      return 180
    case "365d":
      return 365
    case "1095d":
      return 1095
    case "1825d":
      return 1825
    case "max":
      return ZOOM_ENUM.MAX
    case "ytd":
      return ZOOM_ENUM.YTD
    case "4fullq":
      return ZOOM_ENUM.FOUR_FULL_QUARTERS
  }

  throw new Error(`Unknown zoom value: ${zoom}`)
}
